function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDotBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12.8973,
    cy: 6.00078,
    r: 1.2,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8973,
    cy: 12.0008,
    r: 1.2,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.8973,
    cy: 18.0008,
    r: 1.2,
    fill: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDotBlack);
export default __webpack_public_path__ + "static/media/menuDotBlack.6c74b45d3bebbe670dbb16deb9a18e46.svg";
export { ForwardRef as ReactComponent };